var render, staticRenderFns
import script from "./StartKYC.vue?vue&type=script&lang=js"
export * from "./StartKYC.vue?vue&type=script&lang=js"
import style0 from "./StartKYC.vue?vue&type=style&index=0&id=66aca518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aca518",
  null
  
)

export default component.exports